import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { DownloadUnit } from '../models/download-unit.model'
import { Observable } from 'rxjs'
import { ArtistId } from '../models/artist.model'
import * as moment from 'moment'

@Injectable({
  providedIn: 'root',
})
export class DownloadUnitGraphService {
  constructor(private functions: AngularFireFunctions) {}

  find(artistId: ArtistId, from: Date, to: Date): Observable<DownloadUnit[]> {
    return this.functions.httpsCallable<
      { artistId: ArtistId; from: string; to: string },
      DownloadUnit[]
    >('findDownloadsGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
